import HttpError from './HttpError';

class HttpBadRequestError extends HttpError {
  constructor(message) {
    super(message, 400);
  }
}

export default HttpBadRequestError;
